import type { GetRefundsParams } from '../types/refundsTypes'

export const refundKeys = {
  all: ['treasury', 'refunds'] as const,

  lists: () => [...refundKeys.all, 'list'] as const,
  list: (filters: GetRefundsParams) => [...refundKeys.lists(), filters] as const,

  details: () => [...refundKeys.all, 'detail'] as const,
  detail: (id: string) => [...refundKeys.details(), id] as const,

  statusCounts: () => [...refundKeys.all, 'statusCounts'] as const,
}
